// extracted by mini-css-extract-plugin
export default {"text":"ProcessFailedModal_text__FyDL1","btnGroup":"ProcessFailedModal_btnGroup__b101s","btnGroup__groupBtn2":"ProcessFailedModal_btnGroup__groupBtn2__Pb6ds"};